'use strict';

var toPull = require('stream-to-pull-stream');

var deferred = require('pull-defer');

var pump = require('pump');

var moduleConfig = require('./utils/module-config');

var PingMessageStream = require('./utils/ping-message-stream');

module.exports = function (arg) {
  var send = moduleConfig(arg);
  return function (id) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Default number of packtes to 1
    if (!opts.n && !opts.count) {
      opts.n = 1;
    }

    var request = {
      path: 'ping',
      args: id,
      qs: opts
    };
    var p = deferred.source();
    var response = new PingMessageStream();
    send(request, function (err, stream) {
      if (err) {
        return p.abort(err);
      }

      pump(stream, response);
      p.resolve(toPull.source(response));
    });
    return p;
  };
};